import { render, staticRenderFns } from "./blind-boxmax.vue?vue&type=template&id=a8c26b82&scoped=true&"
import script from "./blind-boxmax.vue?vue&type=script&lang=js&"
export * from "./blind-boxmax.vue?vue&type=script&lang=js&"
import style0 from "./blind-boxmax.vue?vue&type=style&index=0&id=a8c26b82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c26b82",
  null
  
)

export default component.exports